// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/widget-host-config-schema',
  type: 'object',
  required: ['id', 'creatorId'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    name: {
      type: 'string',
      nullable: true,
    },
    hostKey: {
      type: 'string',
      nullable: true,
    },
    loaderUrl: {
      type: 'string',
      nullable: true,
    },
    allowedReferers: {
      type: 'string',
      nullable: true,
    },
    languageIso2: {
      type: 'string',
      nullable: true,
    },
    locale: {
      type: 'string',
      nullable: true,
    },
    entryPoint: {
      type: 'string',
      nullable: true,
    },
    navigation: {
      type: 'string',
      nullable: true,
    },
    startParameters: {
      type: 'string',
      nullable: true,
    },
    apiKey: {
      type: 'string',
      nullable: true,
    },
    isDebug: {
      type: 'boolean',
    },
    isActive: {
      type: 'boolean',
    },
    textContentScope: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
